import { render, staticRenderFns } from "./PanelComponent.vue?vue&type=template&id=e8704d8c"
import script from "./PanelComponent.vue?vue&type=script&lang=js"
export * from "./PanelComponent.vue?vue&type=script&lang=js"
import style0 from "./PanelComponent.vue?vue&type=style&index=0&id=e8704d8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports